import { Breakpoint, useBreakpoint } from '~/utils'
import { GridPosition } from '~/types/drill'
import { getMobileGridPosition, getTabletGridPosition } from '~/components/Drill/DrillTopic/helpers'

export default function useGetGridPositionFunction(
  getDesktopGridPosition: (index: number) => GridPosition,
): (index: number) => GridPosition {
  const br = useBreakpoint()

  if (br < Breakpoint.MD) {
    return getMobileGridPosition
  }

  if (br < Breakpoint.XL) {
    return getTabletGridPosition
  }

  return getDesktopGridPosition
}
